export class StringHelpers {
    static extractInitials(name: string) {
        if (!name) {
            return "";
        }
        if (name?.includes("@")) {
            name = name.split("@")?.[0];
        }
        name = name.replaceAll(".", " ");
        name = name.replaceAll("_", " ");
        name = name.replaceAll("-", " ");
        name = name.replace(/\s\s+/g, " ");
        const segments = (name ?? "").split(" ");
        if (segments.length > 1) {
            return (
                name[0]?.toUpperCase()?.trim() + segments[1]?.[0]?.toUpperCase()?.trim()
            );
        } else if (segments.length == 1 && name?.length) {
            return name[0]?.toUpperCase()?.trim() ?? "";
        } else return name;
    }

    static ConditionalCombine(
        ...ifsAndButs: {
            if: () => boolean | undefined | null;
            show: string | undefined | null;
        }[]
    ) {
        const result: (string | undefined | null)[] = [];

        for (const ifAndBut of ifsAndButs) {
            if (ifAndBut.if()) {
                result.push(ifAndBut.show);
            }
        }

        return result.join(", ");
    }
}
